export default __webpack_public_path__ + "static/media/Settingright.687e21294f41b0a59f5a1f34ba73053a.svg";